import './App.css';
import AdminRoutes from './routes/AdminRoutes';
import PublicRoutes from './routes/PublicRoutes';

function App() {
  return (
    <>
      <PublicRoutes />
      <AdminRoutes />
    </>
  );
}

export default App;
